var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DataStatus"},[_c('div',{staticClass:"status"},[_c('span',{staticClass:"text"},[_vm._v("企业发票数据")])]),_c('div')])
}]

export { render, staticRenderFns }